import React from 'react'

const PayableView = () => {
  return (
    <div>PayableView</div>
  )
}

export default PayableView